import {memo, useRef} from 'react';
import AdminBanner from './AdminBanner';
import MomentBanner from './MomentBanner';
import MomentNativeBanner from './MomentNativeBanner';
import {HomeTabPage} from '../../../home/common/type';
import {IS_CBT_OR_PROD} from '../../constant';
import {Page} from '../../constant/page';
import useIntersection from '../../hook/useIntersection';
import {IAdBanner, IAdBannerPage, IMomenBannerType} from '../../type';

interface IProps {
  className?: string;
  banner: IAdBanner;
  onLoadMoment?: () => void;
  onIntersection?: (isIntersecting: boolean) => void;
  onClick?: (e: any, id?: string) => void;
  contentId?: number;
}

function AdBanner({
  className,
  banner,
  onLoadMoment,
  onIntersection,
  onClick,
  contentId,
}: IProps) {
  const bannerRef = useRef<HTMLDivElement>(null);

  useIntersection({targetRef: bannerRef, onIntersection});

  if (banner.isMoment) {
    const {page, type, defaultBanner, id} = banner;
    const unitId = IS_CBT_OR_PROD
      ? MOMENT_BANNER_REAL_KEY_MAP[page]
      : MOMENT_BANNER_DEV_KEY_MAP[page];
    const {w, h} = BANNER_SIZE_MAP[type];
    return (
      <div
        className={cn('overflow-hidden rounded-8', className)}
        ref={bannerRef}
        onClick={e => onClick?.(e, id)}
      >
        {type === 'adBigMoment' && contentId && (
          <MomentNativeBanner
            unitId={unitId}
            contentId={contentId}
            w={w}
            defaultBanner={defaultBanner}
          />
        )}
        {type === 'adMoment' && (
          <MomentBanner
            unitId={unitId}
            w={w}
            h={h}
            defaultBanner={defaultBanner}
            // TODO: banner SDK가 업데이트 되면서 임의로 높이값을 변경시키는 버그가 있어서 임시로 작성
            // 참고: https://podotree.atlassian.net/browse/KWQA-18571
            bannerClassName={h === 68 ? '!max-h-68 !min-h-68' : undefined}
            onLoadMoment={onLoadMoment}
          />
        )}
      </div>
    );
  }

  if (!banner.isMoment && banner.type !== 'default') {
    return (
      <div className={className} ref={bannerRef} onClick={onClick}>
        <AdminBanner type={banner.type} adminAd={banner.adminAd} />
      </div>
    );
  }

  if (banner.type === 'default' && banner.defaultBanner) {
    return <AdminBanner type="adMoment" adminAd={banner.defaultBanner} />;
  }

  return null;
}

export default memo(AdBanner);

// https://podotree.atlassian.net/wiki/spaces/KW/pages/1557267353/2#%EC%97%B0%EB%8F%99-%ED%94%8C%EB%9E%AB%ED%8F%BC-%2F-%EC%97%B0%EB%8F%99-%EA%B0%80%EC%9D%B4%EB%93%9C
// TODO: 모먼트 배너 테스트할 수 있게 웅에게 요청하자.
const MOMENT_BANNER_DEV_KEY_MAP: {[key in IAdBannerPage]: string} = {
  [Page.Content]: 'DAN-60ZKinu1EBLNGm9L',
  [HomeTabPage.TimeTable]: 'DAN-QcmSOBoUKZPuXkU9',
  [Page.Viewer]: 'DAN-rdON8yUqlWhNEfEW',
  [HomeTabPage.Ranking]: 'DAN-HiO9YfZvXlc73HlV',
};
const MOMENT_BANNER_REAL_KEY_MAP: {[key in IAdBannerPage]: string} = {
  [Page.Content]: 'DAN-KMwxCDU2bCKsdN9W',
  [HomeTabPage.TimeTable]: 'DAN-WyT7BVQgtO8ISq7u',
  [Page.Viewer]: 'DAN-LmEqK025RFpDem1s',
  [HomeTabPage.Ranking]: 'DAN-zvvxDBuSsTrTzlnL',
};

const BANNER_SIZE_MAP: {
  [key in IMomenBannerType]: {w: number; h: number};
} = {
  adMoment: {w: 375, h: 68},
  adBigMoment: {w: 428, h: 195},
};
